export default 'tl_concierge_message_received';



// WEBPACK FOOTER //
// ./src/constants/conciergeMessageReceivedKey.js